
import React from 'react';
import { MultiSelect } from './MultiSelect';
import { FilterSection } from './FilterSection';
import { LeadStatus, LeadType, LeadOutcome } from '../types/LeadTypes';
import { FilterOption } from './filterOptions';
import { getOutcomeCircleColor } from '../LeadUtils';

interface TypeStatusOutcomeFiltersProps {
  statusOptions: FilterOption[];
  typeOptions: FilterOption[];
  outcomeOptions: FilterOption[];
  selectedStatuses: LeadStatus[];
  selectedTypes: LeadType[];
  selectedOutcomes: LeadOutcome[];
  onStatusChange: (selected: string[]) => void;
  onTypeChange: (selected: string[]) => void;
  onOutcomeChange: (selected: string[]) => void;
}

export const TypeStatusOutcomeFilters: React.FC<TypeStatusOutcomeFiltersProps> = ({
  statusOptions,
  typeOptions,
  outcomeOptions,
  selectedStatuses,
  selectedTypes,
  selectedOutcomes,
  onStatusChange,
  onTypeChange,
  onOutcomeChange
}) => {
  return (
    <>
      <FilterSection id="type-filter" label="Type">
        <MultiSelect 
          id="type-filter"
          options={typeOptions}
          selectedValues={selectedTypes}
          onChange={onTypeChange}
          placeholder="Select"
          showIcons={true}
        />
      </FilterSection>
      
      <FilterSection id="status-filter" label="Status">
        <MultiSelect 
          id="status-filter"
          options={statusOptions}
          selectedValues={selectedStatuses}
          onChange={onStatusChange}
          placeholder="Select"
          showIcons={true}
        />
      </FilterSection>
      
      <FilterSection id="outcome-filter" label="Outcome">
        <MultiSelect 
          id="outcome-filter"
          options={outcomeOptions}
          selectedValues={selectedOutcomes}
          onChange={onOutcomeChange}
          placeholder="Select"
          showColorCircles={true}
          getCircleColor={getOutcomeCircleColor}
        />
      </FilterSection>
    </>
  );
};
